卫星遥感解译服务产品
<template>
  <div class="main-div">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- 建筑物专题信息产品 -->
      <el-tab-pane label="建筑物专题信息产品" name="first">
        <div class="mainDiv">
          <div class="chanpin">
            <h2>产品介绍</h2>
            <br />
            <p
              class="text_desc"
            >城市建筑物分布是遥感信息智能提取的重要研究对象，也是城市可持续发展的重要数据源之一。近年来，随着高分辨率遥感卫星快速发展，遥感进入大数据时代，高分辨率的城市建筑物专题信息产品应运而生。通过分析大尺度高分 辨率城市建筑物制图中的困难，研发了一种城市建筑物提取策略与制图框架，能够提供高分辨率城市建筑物专题信息产品。</p>
          </div>
          <div class="jishu">
            <p>技术流程</p>
            <el-image fit="contain" src="../../../../static/officeImg/index/jishu1.png" alt />
          </div>
          <div class="chenguo">
            <p>成果样例展示</p>
            <div class="chenguo_img">
              <el-image
                fit="contain"
                src="../../../../static/officeImg/index/chengguo1_1.png"
                alt
                class="chenguo_img_img"
              />
              <el-image
                fit="contain"
                src="../../../../static/officeImg/index/chengguo1_2.png"
                alt
                class="chenguo_img_img"
              />
            </div>
          </div>
          <!-- 获取方式 -->
          <p class="quyuOne_h2">数据获取方式</p>
          <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column prop="date" label="项目"></el-table-column>
            <el-table-column prop="name" label="交易方式"></el-table-column>
            <el-table-column prop="address" label="生产周期"></el-table-column>
            <el-table-column prop="phone" label="购买渠道"></el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <!-- 集中式光伏发电站专题信息产品 -->
      <el-tab-pane label="集中式光伏发电站专题信息产品" name="second">
        <div class="mainDiv">
          <div class="chanpin">
            <h2>产品介绍</h2>
            <br />
            <p
              class="text_desc"
            >太阳能资源以其取之不尽用之不竭且没有任何污染的优势成为缓解地球能源短缺的重要资源，利用光伏面板进行光电转换是未来发电的重要途径，是促进全球“碳达峰，碳中和”的可持续发展目标的重要动力。基于多源多尺度遥感数据研发了集中式光伏电站专题信息产品，具备大尺度专题信息产品交付能力。</p>
          </div>
          <div class="jishu">
            <p>技术流程</p>
            <el-image fit="contain" src="../../../../static/officeImg/index/jishu2.png" alt />
          </div>
          <div class="chenguo">
            <p>成果样例展示</p>
            <div class="chenguo_img">
              <el-image
                fit="contain"
                src="../../../../static/officeImg/index/chengguo2_1.png"
                alt
                class="chenguo_img_img"
              />
              <el-image
                fit="contain"
                src="../../../../static/officeImg/index/chengguo2_2.png"
                alt
                class="chenguo_img_img"
              />
            </div>
          </div>
          <!-- 获取方式 -->
          <p class="quyuOne_h2">数据获取方式</p>
          <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column prop="date" label="项目"></el-table-column>
            <el-table-column prop="name" label="交易方式"></el-table-column>
            <el-table-column prop="address" label="生产周期"></el-table-column>
            <el-table-column prop="phone" label="购买渠道"></el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "first",
      //表格
      tableData: [
        {
          date: "高清影像",
          name: "存档，或按项目区域定制",
          address: "存档数据5个工作日内交付",
          phone: "采购电话：18610570353（葛经理）",
        },
      ],
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style scoped>
::-webkit-scrollbar {
  width: 4px;
  height: 10px;
}
::-webkit-scrollbar-track {
  /* background-color: darkgrey; */
  background-color: white;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.6);
  border-radius: 4px;
}
.main-div {
  width: 70%;
  margin: 0 auto;
}
.mainDiv {
  height: 1300px;
  overflow: auto;
}
.chanpin {
  width: 100%;
  text-align: left;
  padding: 10px;
  font-size: 18px;
}
.chanpin h2 {
  font-size: 22px;
  color: #1c72dc;
  text-align: center;
}
.text_desc {
  letter-spacing: 5px;
  text-indent: 38px;
  text-align: left;
}
/* 技术 */
.jishu {
  text-align: left;
  font-size: 20px;
  font-weight: normal;
  margin-top: 20px;
  color: #1c72dc;
}
.jishu img {
  width: 100%;
}
/* 成果 */
.chenguo {
  width: 100%;
  height: 500px;
  font-size: 20px;
  font-weight: normal;
  text-align: left;
  color: #1c72dc;
  margin: 40px 0px;
}
.chenguo_img {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chenguo_img_img {
  display: block;
  width: 40%;
  height: 480px;
  margin: 15px;
}
/* 数据获取方式 */
.quyuOne_h2 {
  font-size: 20px;
  font-weight: normal;
  color: #1c72dc;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/remoteDigData/components/interpreting.vue